<template>
  <div>
    <div v-show="divShow">
      <div class="contain1">
        <a-row>
          <a-col :span="24" class="col-accum-data">
            <a-spin :spinning="spinning.accum">
              <div class="accum-data">
                <span class="span-title">累计数据</span>
                <a-row type="flex" justify="start">
                  <a-col :span="8">
                    <div class="accum-title">交易总额</div>
                    <div class="accum-number">
                      {{accumData.tradeamttotal}}
                      <font style="font-size:16px">元</font>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="accum-title">培训合同数</div>
                    <div class="accum-number">{{accumData.contractnum}}</div>
                  </a-col>
                  <a-col :span="8">
                    <div class="accum-title">预付培训费金额</div>
                    <div class="accum-number">
                      {{accumData.superviseamttotal}}
                      <font style="font-size:16px">元</font>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="accum-title">正在执行合同金额</div>
                    <div class="accum-number">
                      {{accumData.progress_constamt}}
                      <font style="font-size:16px">元</font>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="accum-title">正在执行合同总数</div>
                    <div class="accum-number">
                      {{accumData.progress_contractnum}}
                      <font style="font-size:16px"></font>
                    </div>
                  </a-col>
                  <a-col :span="8">
                    <div class="accum-title">正在执行合同预付培训费金额</div>
                    <div class="accum-number">
                      {{accumData.progress_superviseamttotal}}
                      <font style="font-size:16px">元</font>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-spin>
            <!-- <a-spin :spinning="spinning.map">
              <div :style="mapStyle" style="margin-bottom:50px">
                <v-chart :options="map"/>
              </div>
            </a-spin> -->
          </a-col>
          <!-- <a-col :span="6" class="col-top">
            <a-spin :spinning="spinning.top">
              <div class="top" style="margin-left:10%">
                <span class="span-title">TOP1驾校</span>
                <div style="margin-bottom:40px">
                  <div class="accum-title">培训收入最高</div>
                  <div class="driveschool">{{topData.incomeschname}}</div>
                  <div class="accum-number">{{topData.incomenum}}元</div>
                </div>
                <div style="margin-bottom:40px">
                  <div class="accum-title">培训合同数最多</div>
                  <div class="driveschool">{{topData.contractschname}}</div>
                  <div class="accum-number">{{topData.contractnum}}</div>
                </div>
              </div>
            </a-spin>
          </a-col> -->
        </a-row>
      </div>
      <a-divider/>
      <div style="margin-top:40px">
        <a-radio-group defaultValue="a" buttonStyle="solid" v-model="checked">
          <a-radio-button value="a" @click="getDate(0)">近一周</a-radio-button>
          <a-radio-button value="b" @click="getDate(1)">近一个月</a-radio-button>
          <a-radio-button value="c" @click="getDate(2)">近一年</a-radio-button>
        </a-radio-group>
      </div>
      <a-row style="margin-top:40px">
        <a-col :span="16">
          <a-spin :spinning="spinning.personBar">
            <span class="span-title">{{title}}新增合同数统计</span>
            <e-bar :xAxis="pernumxAxis" :series="pernumSeries"></e-bar>
          </a-spin>
        </a-col>
        <a-col :span="6" :offset="2"> 
          <a-spin :spinning="spinning.personSort">
            <span class="span-title">驾校新签合同排名</span>
            <div style="margin-top:25px">
              <div>
                <a-row v-for="(person,idx)  in personSortData.slice(0,6)" :key="idx" :gutter=16 style="padding-bottom:15px ">
                  <a-col :span="3">
                    <div v-if="idx < 3" class="train-person-sorttop">{{idx+1}}</div>
                    <div v-else class="train-person-sort">{{idx+1}}</div>
                  </a-col>
                  <a-col :span="11">
                    <div class="train-person-school">{{person.drivschshtname}}</div>
                  </a-col>
                  <a-col :span="10">
                    <div class="train-person-number">{{person.num}}</div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-spin>
        </a-col>
      </a-row>
      <a-row style="margin-top:40px">
        <a-col :span="16">
          <a-spin :spinning="spinning.incomeLine">
            <span class="span-title">{{title}}培训收入统计</span>
            <e-line :xAxis="incomexAxis" :series="incomeSeries"></e-line>
          </a-spin>
        </a-col>
        <a-col :span="6" :offset="2">
          <a-spin :spinning="spinning.incomeSort">
            <span class="span-title">驾校培训收入排名</span>
            <div style="margin-top:25px">
              <div>
                <a-row v-for="(income,idx)  in incomeSortData.slice(0,6)" :key="idx" :gutter=16 style="padding-bottom:15px ">
                  <a-col :span="3">
                    <div v-if="idx < 3" class="train-person-sorttop">{{idx+1}}</div>
                    <div v-else class="train-person-sort">{{idx+1}}</div>
                  </a-col>
                  <a-col :span="11">
                    <div class="train-person-school">{{income.drivschshtname}}</div>
                  </a-col>
                  <a-col :span="10">
                    <div class="train-person-number">{{income.incomenum}}</div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-spin>
        </a-col>
      </a-row>
      <a-row style="margin-top:40px">
        <a-col :span="16">
          <a-spin :spinning="spinning.moneyBar">
            <span class="span-title">{{title}}新增合同总预付培训费金额</span>
            <e-bar :xAxis="moneyxAxis" :series="moneySeries"></e-bar>
          </a-spin>
        </a-col>
        <a-col :span="6" :offset="2">
          <a-spin :spinning="spinning.moneySort">
            <span class="span-title">驾校新增合同预付培训费金额排名</span>
            <div style="margin-top:25px">
              <div>
                <a-row v-for="(money,idx)  in supMoneySortData.slice(0,6)" :key="idx" :gutter=16 style="padding-bottom:15px ">
                  <a-col :span="3">
                    <div v-if="idx < 3" class="train-person-sorttop">{{idx+1}}</div>
                    <div v-else class="train-person-sort">{{idx+1}}</div>
                  </a-col>
                  <a-col :span="11">
                    <div class="train-person-school">{{money.drivschshtname}}</div>
                  </a-col>
                  <a-col :span="10">
                    <div class="train-person-number">{{money.superviseamttotal}}</div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-spin>
        </a-col>
      </a-row>
      <a-row style="margin-top:40px">
        <a-col :span="16">
          <a-spin :spinning="spinning.contractAtmBar">
            <span class="span-title">{{title}}新增合同总金额</span>
            <e-bar :xAxis="contractAtmxAxis" :series="contractAtmSeries"></e-bar>
          </a-spin>
        </a-col>
        <a-col :span="6" :offset="2">
          <a-spin :spinning="spinning.contractAtmSort">
            
          </a-spin>
        </a-col>
      </a-row>
      <a-row style="margin-top:40px">
        <a-col :span="12">
          <a-spin :spinning="spinning.newsupAmtrank">
            <div>
              <span class="span-title">新增合同总预付培训费金额占比</span>
              <e-pie :dataSource="newsupAmtrank" :name="'新增合同总预付培训费金额'"/>
            </div>
          </a-spin>
        </a-col>
        <a-col :span="12">
          <a-spin :spinning="spinning.newcontractAmtrank">
            <div>
              <span class="span-title">新增合同总金额占比</span>
              <e-pie :dataSource="newcontractAmtrank" :name="'新增合同总金额占比'"/>
            </div>
          </a-spin>
        </a-col>
        <a-col :span="12">
          <a-spin :spinning="spinning.newContractPie">
            <div>
              <span class="span-title">各驾校新增合同占比</span>
              <e-pie :dataSource="newContract" :name="'新增合同'"/>
            </div>
          </a-spin>
        </a-col>
      </a-row>
      <div style="margin-top:30px">
        <span class="span-title">下属驾校信息</span>
        <j-table
          style="margin-top:20px;"
          :tableColumns="columns"
          :rowKey="record => record.drivschid"
          :tableData="schoolList"
          :loading="loading"
          :tablePagination="pagination"
          v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;getSchoolList(); }"
          v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;getSchoolList(); }"
        >
          <template v-slot="record">
            <a @click="showDetails(record)">详情</a>
          </template>
        </j-table>
      </div>
    </div>

    <d-school
      v-if="detailShow"
      :parameters="params"
      v-on:onClose="()=>{detailShow = false;divShow = true;}"
    ></d-school>
  </div>
</template>



<script>
import mixins from "../../mixins";
import ECharts from "vue-echarts";
import JTable from "../../components/JTable";
import DSchool from "../../components/SchoolDetails";
import DAssociation from "../../components/AssociationDetails";
import moment from "moment";

import EBar from "../../components/Bar";
import ELine from "../../components/Line";
import EPie from "../../components/Pie";

const clientWidth = document.body.clientWidth;

const weekStart = moment().subtract(1,'week').format("YYYY-MM-DD");
const weekEnd = moment().format("YYYY-MM-DD");
const monthStart =moment().subtract(1,'month').format("YYYY-MM-DD");
const monthEnd = moment().format("YYYY-MM-DD");
const yearStart = moment().subtract(1,'year').format("YYYY-MM-DD");
const yearEnd = moment().format("YYYY-MM-DD");
/**
 * 下属驾校表头
 */
const columns = [
  {
    title: "驾校简称",
    dataIndex: "drivschshtname",
    key: "drivschshtname",
    fixed: "left",
    align: "center"
  },
  //   {
  //     title: "驾校ID",
  //     dataIndex: "drivschid",
  //     key: "drivschid",
  //     fixed: "left",
  //     align: "center"
  //   },
  {
    title: "驾校名称",
    dataIndex: "drivschname",
    key: "drivschname",
    align: "center",
    fixed: "left"
  },
  //   {
  //     title: "驾协ID",
  //     dataIndex: "drivasstid",
  //     key: "drivasstid",
  //     align: "center"
  //   },
  //   {
  //     title: "创建时间",
  //     dataIndex: "credatetime",
  //     key: "credatetime",
  //     align: "center"
  //   },
  //   { title: "创建人ID", dataIndex: "inputop", key: "inputop", align: "center" },
  { title: "城市代码", dataIndex: "city", key: "city", align: "center" },
  {
    title: "驾校地址",
    dataIndex: "drivschadress",
    key: "drivschadress",
    align: "center"
  },
  { title: "省代码", dataIndex: "provice", key: "provice", align: "center" },
  { title: "区县代码", dataIndex: "county", key: "county", align: "center" },
  {
    title: "联系人名称",
    dataIndex: "contactsname",
    key: "contactsname",
    align: "center"
  },
  {
    title: "联系人邮箱",
    dataIndex: "contactsemail",
    key: "contactsemail",
    align: "center",
    width: 200
  },
  {
    title: "联系人手机",
    dataIndex: "contactsmobile",
    key: "contactsmobile",
    align: "center"
  },
  {
    title: "联系人电话",
    dataIndex: "contactsphone",
    key: "contactsphone",
    align: "center",
    width: 200
  },
  {
    title: "财务名称",
    dataIndex: "fincontactsname",
    key: "fincontactsname",
    align: "center"
  },
  {
    title: "财务手机",
    dataIndex: "finacontactsmobile",
    key: "finacontactsmobile",
    align: "center"
  },
  {
    title: "财务邮箱",
    dataIndex: "fincontactsemail",
    key: "fincontactsemail",
    align: "center",
    width: 200
  },
  {
    title: "财务电话",
    dataIndex: "fincontactsphone",
    key: "fincontactsphone",
    align: "center",
    width: 200
  },
  //   {
  //     title: "修改时间",
  //     dataIndex: "moddatetime",
  //     key: "moddatetime",
  //     align: "center"
  //   },
  //   { title: "修改人", dataIndex: "modopr", key: "modopr", align: "center" },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center",
    fixed: "right",
    width: 100
  }
];
export default {
  name: "dashboard",
  components: {
    "v-chart": ECharts,
    JTable,
    DSchool,
    EBar,
    ELine,
    EPie
  },
  mixins: [mixins],
  
  data() {
    return {
      drivasstid: this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
      title: "近一周",
      checked: "a",
      spinning: {
        accum: false,
        map: false,
        top: false,
        personBar: false,
        personSort: false,
        incomeLine: false,
        incomeSort: false,
        moneyBar: false,
        moneySort: false,
        personPie: false,
        incomePie: false,
        validContractPie: false,
        newsupAmtrank:false,
        newcontractAmtrank:false,
        newContractPie: false,
        pass: false,
        statistics:false,
        contractAtmBar:false,
        contractAtmSort:false
      },
      mapStyle: {
        width: ((clientWidth - 300) / 4) * 3 + "px",
        height: (clientWidth - 300) / 2 + "px"
      },
      sortStyle: {
        height: (clientWidth - 300) / 4 / 7 + "px"
      },
      columns,
      loading: false,
      pagination: {
        pageSize: 10,
        pageSizeOptions: ["1", "10", "20", "50", "100"],
        current: 1,
        total: 0
      },
      orderby: "drivasstid desc",
      drivasstName: "",
      startDate: weekStart,
      endDate: weekEnd,
      dateFormat: "YYYY-MM-DD",
      accumData: {},
      topData: {},
      trainIncomeData: {},
      schoolList: [],
      params: {},
      divShow: true,
      detailShow: false,
      flag: "0",
      personSortData: [],
      incomeSortData: [],
      supMoneySortData: [],
      pernumxAxis: [],
      pernumSeries: {
        data: [],
        name: "合同数量"
      },
      moneyxAxis: [],
      moneySeries: {
        data: [],
        name: "预付培训费金额"
      },
      contractAtmxAxis:[],
      contractAtmSeries: {
        data: [],
        name: "合同金额"
      },
      incomexAxis: [],
      incomeSeries: {
        data: [],
        name: "培训收入"
      },
      statisticsPer: {
        list: [],
        total: ""
      },
      statisticsInco: {
        list: [],
        total: ""
      },
      validContract:[],
      newContract:[],
      newsupAmtrank:[],
      newcontractAmtrank:[]
    };
  },
  created() {
    this.getAccumData();
    this.echartsChange();
    
    this.getNewsupAmtrank();
    this.getNewcontractAmtrank();
    this.getNewContract();
    this.getSchoolList();
  },
  methods: {
    moment,
    getDate(value) {
      //本周、本月、本年
      if (value === 0) {
        this.startDate = weekStart;
        this.endDate = weekEnd;
        this.flag = "0";
        this.title = "近一周";
      } else if (value === 1) {
        this.startDate = monthStart;
        this.endDate = monthEnd;
        this.flag = "1";
        this.title = "近一个月";
      } else if (value === 2) {
        this.startDate = yearStart;
        this.endDate = yearEnd;
        this.flag = "2";
        this.title = "近一年";
      }
      this.echartsChange();
    },
    showDetails(record) {
      this.divShow = false;
      this.detailShow = true;
      this.params = {
        drivschid: record.drivschid,
        drivasstid: record.drivasstid
      };
    },
    echartsChange() {
      //根据日期获取所有统计图数据
      this.getTrainperson();
      this.getTrainIncome();
      this.getSupMoney();
      this.getContractAtm();
      this.getPersonSort();
      this.getIncomeSort();
      this.getSupMoneySort();
    },
    getAccumData() {
      //获取累计数据，包含交易总额、培训合同数、通过率、监管总金额
      const that = this;
      that.accumData = {};
      that.spinning.accum = true;
      const reqData = {
        drivasstid: that.drivasstid,
        drivschid: ""
      };
      this.$http.post(
        this.$marco.api.accumData,
        reqData,
        data => {
          this.$log.success("累计数据---------" + JSON.stringify(data));
          that.spinning.accum = false;
          that.accumData = data;
        },
        errorDesc => {
          that.spinning.accum = false;
          this.$log.normal("累计数据---------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.accum = false;
          this.$log.error("累计数据---------" + JSON.stringify(error));
        }
      );
    },
    
    getTrainperson() {
      //获取培训人数
      const that = this;
      that.spinning.personBar = true;
      const reqData = {
        datestart: that.startDate.replace(/-/g, ""),
        dateend: that.endDate.replace(/-/g, ""),
        drivasstid: that.drivasstid,
        flag: that.flag
      };
      this.$http.post(
        this.$marco.api.trainPerson,
        reqData,
        data => {
          this.$log.success("培训人数统计---------" + JSON.stringify(data));
          that.spinning.personBar = false;
          that.pernumSeries.data = data.series.data;
          that.pernumxAxis = data.xAxis.data;
        },
        errorDesc => {
          that.spinning.personBar = false;
          this.$log.normal("培训人数统计---------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.personBar = false;
          this.$log.error("培训人数统计---------" + JSON.stringify(error));
        }
      );
    },
    getPersonSort() {
      //获取驾校培训人数排名
      const that = this;
      that.spinning.personSort = true;
      that.personSortData = [];
      const reqData = {
        drivasstid: that.drivasstid,
        drivschid: "",
        beginDate: that.startDate.replace(/-/g, ""),
        endDate: that.endDate.replace(/-/g, ""),
        num: 6
      };
      this.$http.post(
        this.$marco.api.personSort,
        reqData,
        data => {
          this.$log.success("人数排名------" + JSON.stringify(data));
          that.spinning.personSort = false;
          that.personSortData = that.personSortData.concat(
            data.studentranklist
          );
        },
        errorDesc => {
          that.spinning.personSort = false;
          this.$log.normal("人数排名------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.personSort = false;
          this.$log.error("人数排名------" + JSON.stringify(error));
        }
      );
    },
    getTrainIncome() {
      //获取培训收入
      const that = this;
      that.spinning.incomeLine = true;
      const reqData = {
        datestart: that.startDate.replace(/-/g, ""),
        dateend: that.endDate.replace(/-/g, ""),
        drivasstid: that.drivasstid,
        flag: that.flag
      };
      this.$http.post(
        this.$marco.api.trainIncome,
        reqData,
        data => {
          this.$log.success("培训收入=========" + JSON.stringify(data));
          that.spinning.incomeLine = false;
          that.incomeSeries.data = data.series.data;
          that.incomexAxis = data.xAxis.data;
        },
        errorDesc => {
          that.spinning.incomeLine = false;
          this.$log.normal("培训收入=========" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.incomeLine = false;
          this.$log.error("培训收入=========" + JSON.stringify(error));
        }
      );
    },
    getIncomeSort() {
      //获取驾校培训收入排名
      const that = this;
      that.spinning.incomeSort = true;
      that.incomeSortData = [];
      const reqData = {
        drivasstid: that.drivasstid,
        drivschid: "",
        beginDate: that.startDate.replace(/-/g, ""),
        endDate: that.endDate.replace(/-/g, ""),
        num: 6
      };
      this.$http.post(
        this.$marco.api.incomeSort,
        reqData,
        data => {
          this.$log.success("收入排名------" + JSON.stringify(data));
          that.spinning.incomeSort = false;
          that.incomeSortData = that.incomeSortData.concat(data.incomeranklist);
        },
        errorDesc => {
          that.spinning.incomeSort = false;
          this.$log.normal("收入排名------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.incomeSort = false;
          this.$log.error("收入排名------" + JSON.stringify(error));
        }
      );
    },
    getSupMoney() {
      //获取监管金额
      const that = this;
      that.spinning.moneyBar = true;
      const reqData = {
        datestart: that.startDate.replace(/-/g, ""),
        dateend: that.endDate.replace(/-/g, ""),
        drivasstid: that.drivasstid,
        flag: that.flag
      };
      this.$http.post(
        this.$marco.api.supMoney,
        reqData,
        data => {
          this.$log.success("监管金额---------" + JSON.stringify(data));
          that.spinning.moneyBar = false;
          that.moneySeries.data = data.series.data;
          that.moneyxAxis = data.xAxis.data;
        },
        errorDesc => {
          that.spinning.moneyBar = false;
          this.$log.normal("监管金额---------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.moneyBar = false;
          this.$log.error("监管金额---------" + JSON.stringify(error));
        }
      );
    },
    getSupMoneySort() {
      //获取监管金额排名
      const that = this;
      that.spinning.moneySort = true;
      that.supMoneySortData = [];
      const reqData = {
        drivasstid: that.drivasstid,
        drivschid: "",
        beginDate: that.startDate.replace(/-/g, ""),
        endDate: that.endDate.replace(/-/g, ""),
        num: 6
      };
      this.$http.post(
        this.$marco.api.supMoneySort,
        reqData,
        data => {
          this.$log.success("监管金额排名------" + JSON.stringify(data));
          that.spinning.moneySort = false;
          that.supMoneySortData = that.supMoneySortData.concat(
            data.supamtranklist
          );
        },
        errorDesc => {
          that.spinning.moneySort = false;
          this.$log.normal("监管金额排名------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.moneySort = false;
          this.$log.error("监管金额排名------" + JSON.stringify(error));
        }
      );
    },
    getContractAtm() {
      //获取合同金额
      const that = this;
      that.spinning.contractAtmBar = true;
      const reqData = {
        datestart: that.startDate.replace(/-/g, ""),
        dateend: that.endDate.replace(/-/g, ""),
        drivasstid: that.drivasstid,
        flag: that.flag
      };
      this.$http.post(
        this.$marco.api.newContractAtm,
        reqData,
        data => {
          this.$log.success('合同金额---------'+JSON.stringify(data))
          that.spinning.contractAtmBar = false;
          that.contractAtmSeries.data = data.series.data;
          that.contractAtmxAxis = data.xAxis.data;
        },
        errorDesc => {
          that.spinning.contractAtmBar = false;
          this.$log.normal("合同金额---------" + JSON.stringify(errorDesc));
        },
        error => {
          that.spinning.contractAtmBar = false;
          this.$log.error("合同金额---------" + JSON.stringify(error));
        }
      );
    },
    // 新增合同总监管金额占比
    getNewsupAmtrank(){
      const that = this;
      that.newsupAmtrank = [];
      that.$http.post(
        that.$marco.api.newsupAmtrank,
        {
          num:'5',
          drivasstid:that.drivasstid
        },
        data => {
          this.$log.success(JSON.stringify(data));
          data.conranklist.map((item)=>{
            that.newsupAmtrank.push({
              name:item.drivschshtname,
              value:item.progress_superviseamttotal
            })
          });
          that.newsupAmtrank[that.newsupAmtrank.length-1].name = '其他';
          that.spinning.newsupAmtrank= false;
        },
        errorDesc => {
          this.$log.normal(JSON.stringify(errorDesc));
          that.spinning.newsupAmtrank= false;
        },
        error => {
          this.$log.error(JSON.stringify(error));
          that.spinning.newsupAmtrank= false;
        },
        that
      );
    },
    // 新增合同总金额占比
    getNewcontractAmtrank(){
      const that = this;
      that.newcontractAmtrank = [];
      that.$http.post(
        that.$marco.api.newcontractAmtrank,
        {
          num:'5',
          drivasstid:that.drivasstid
        },
        data => {
          this.$log.success(JSON.stringify(data));
          data.conranklist.map((item)=>{
            that.newcontractAmtrank.push({
              name:item.drivschshtname,
              value:item.progress_constamt
            })
          });
          that.newcontractAmtrank[that.newcontractAmtrank.length-1].name = '其他';
          that.spinning.newcontractAmtrank= false;
        },
        errorDesc => {
          
        },
        error => {
          
        },
        that
      );
    },
    // 新增合同数占比
    getNewContract(){
      const that = this;
      that.newContract = [];
      that.spinning.newContractPie= true;
      that.$http.post(
        that.$marco.api.newcontract,
        {
          num:5,
          drivasstid:that.drivasstid
        },
        data => {
          this.$log.success('新增合同--'+JSON.stringify(data));
          data.conranklist.map((item)=>{
            that.newContract.push({
              name:item.drivschshtname,
              value:item.num
            })
          });
          that.newContract[that.newContract.length-1].name = '其他';
          that.spinning.newContractPie= false;
        },
        errorDesc => {
          this.$log.normal('新增合同=='+JSON.stringify(errorDesc));
          that.spinning.newContractPie= false;
        },
        error => {
          this.$log.error('新增合同==='+JSON.stringify(error));
          that.spinning.newContractPie= false;
        },
        that
      );
    },
    getSchoolList() {
      //获取下属驾校列表
      const that = this;
      that.schoolList = [];
      that.loading = true;
      const reqData = {
        currpage: that.pagination.current + "",
        drivasstid: that.drivasstid,
        // drivschname: "",
        orderby: that.orderby,
        recnumperpage: that.pagination.pageSize + ""
      };

      this.$http.post(
        this.$marco.api.drivschPagingList,
        reqData,
        data => {
          that.loading = false;
          this.$log.success(
            "请求成功返回正确数据------" + JSON.stringify(data)
          );
          that.schoolList = that.schoolList.concat(data.pagelist);
          that.pagination["total"] = data.recnum;
        },
        errorDesc => {
          that.loading = false;
          this.$log.normal(
            "请求成功返回失败--------" + JSON.stringify(errorDesc)
          );
        },
        error => {
          that.loading = false;
          this.$log.error("请求失败---------" + JSON.stringify(error));
        }
      );
    },
    convertData(mapData) {
      let res = [];
      for (let i = 0; i < mapData.length; i++) {
        let geoCoord = geoCoordMap[mapData[i].name];
        if (geoCoord) {
          res.push({
            name: mapData[i].name,
            value: geoCoord.concat(mapData[i].value)
          });
        }
      }
      return res;
    }
  }
};
</script>
<style scoped>
/**
 * 默认尺寸为 600px×400px，如果想让图表响应尺寸变化，可以像下面这样
 * 把尺寸设为百分比值（同时请记得为容器设置尺寸）。
 */
.echarts {
  width: 100%;
  height: 100%;
}
.loading {
  opacity: 0.3;
}
.col-top:before {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background-color: #efefef;
}
.col-accum-data:before {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  left: 100%;
  background-color: #efefef;
}
/* .contain1{
    border-bottom: #efefef 10px solid;
} */

.accum-number {
  margin-bottom: 20px;
  font-size: 26px;
  line-height: 30px;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.accum-title {
  margin-top: 15px;
  font-size: 14px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.427450980392157);
}
.driveschool {
  font-size: 20px;
  line-height: 38px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.847058823529412);
}
.span-title {
  font-family: "PingFang-SC-Bold", "PingFang SC Bold", "PingFang SC";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847058823529412);
  text-align: left;
  line-height: 24px;
}
.train-person-sorttop,
.train-income-sorttop,
.train-money-sorttop {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #314659;
  color: white;
  text-align: center;
  line-height: 20px;
  float: left;
}
.train-person-sort,
.train-income-sort,
.train-money-sort {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #f0f2f5;
  color: #333;
  text-align: center;
  line-height: 20px;
}
.train-person-school,
.train-income-school,
.train-money-school {
  font-family: "MicrosoftYaHei", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  text-align: left;
  line-height: 22px;
  color: #3398db;
}
.train-person-number,
.train-income-number,
.train-money-number {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.647058823529412);
  text-align: left;
  line-height: 22px;
}
.train-project {
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.647058823529412);
}
.train-pass-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.427450980392157);
  padding-top: 15px;
}
.train-pass-percent {
  font-size: 28px;
  color: rgba(0, 0, 0, 0.647058823529412);
}
</style> 